import firebase from "firebase/app";
import "firebase/auth";
import { firebaseConfig } from '../config'

export const config = firebase.initializeApp(firebaseConfig);

export function getRecaptchaVerifier(containerId: string) {
  return new (firebase.auth as any).RecaptchaVerifier(containerId, {
    size: "normal",
    callback: () => {},
  });
}